import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { typeAlert } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { userCreateClearData, userPutRolClearData, } from "../../../store/auth/actions";
export var useSuccessHandlers = function (_a) {
    var responseSubmit = _a.responseSubmit, responseUserPutRol = _a.responseUserPutRol, isEdit = _a.isEdit, rolesRows = _a.rolesRows, setOpenModalAddNewUser = _a.setOpenModalAddNewUser, setOpenModalEditRoles = _a.setOpenModalEditRoles, setSeeToast = _a.setSeeToast, resetTriggers = _a.resetTriggers, resetTriggerPutRoles = _a.resetTriggerPutRoles, callUsers = _a.callUsers;
    var dispatch = useDispatch();
    /**
     * Maneja el éxito al crear/editar un usuario
     */
    var handleUserSubmitSuccess = useCallback(function () {
        setSeeToast({
            show: true,
            message: isEdit
                ? "Usuario actualizado con éxito"
                : "Usuario creado con éxito",
            type: typeAlert.success,
        });
        setOpenModalAddNewUser(false);
        resetTriggers();
        callUsers(true);
        dispatch(userCreateClearData());
    }, [
        isEdit,
        setSeeToast,
        setOpenModalAddNewUser,
        resetTriggers,
        callUsers,
        dispatch,
    ]);
    /**
     * Maneja el éxito al asignar/editar roles
     */
    var handleRolesAssignSuccess = useCallback(function () {
        setSeeToast({
            show: true,
            message: rolesRows.length > 0
                ? "Roles editados con éxito"
                : "Roles asignados con éxito",
            type: typeAlert.success,
        });
        setOpenModalEditRoles(false);
        resetTriggerPutRoles();
        callUsers(true);
        dispatch(userPutRolClearData());
    }, [
        rolesRows.length,
        setSeeToast,
        setOpenModalEditRoles,
        resetTriggerPutRoles,
        callUsers,
        dispatch,
    ]);
    // Effect para manejar el éxito de submit
    useEffect(function () {
        if (responseSubmit) {
            handleUserSubmitSuccess();
        }
    }, [responseSubmit, handleUserSubmitSuccess]);
    // Effect para manejar el éxito de asignación de roles
    useEffect(function () {
        if (responseUserPutRol) {
            handleRolesAssignSuccess();
        }
    }, [responseUserPutRol, handleRolesAssignSuccess]);
};
